export const IdRegex = new RegExp(
  '\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}',
  'gi',
);

export const getPathId = (path: string) => {
  const matchedId = path.match(IdRegex);
  const id = matchedId ? matchedId[0].substring(1) : undefined;
  return id;
};

export enum IdType {
  ContentId = 'ContentId',
  CollectionId = 'CollectionId',
  SuggestionId = 'SuggestionId',
  PostId = 'PostId',
}

export const getIdType = (path: string) => {
  if (path.includes('collection')) {
    return IdType.CollectionId;
  } else if (path.includes('request')) {
    return IdType.SuggestionId;
  } else if (path.includes('post')) {
    return IdType.PostId;
  }
  return IdType.ContentId;
};
